export function getAveragePressure (circularGraphics) {
  const csvData = circularGraphics && circularGraphics.pressure_data
  if (csvData) {
    let pressureCsvLines = csvData.split('\n')
    pressureCsvLines.shift()
    if (pressureCsvLines.length > 0) {
      let presSum = 0
      let presCounter = 0
      pressureCsvLines.forEach((line) => {
        let avgValue = line.split(';')
        avgValue = avgValue.reverse()[1]
        if (avgValue) {
          avgValue = avgValue.replace(',', '.')
          avgValue = parseFloat(avgValue)
          if (avgValue && !isNaN(avgValue)) {
            presSum += avgValue
            presCounter++
          }
        }
      })
      return (presCounter) ? presSum / presCounter : null
    }
  }
  return null
}

export function getNumFaults (circularGraphics) {
  const {faults} = circularGraphics || {}
  return (faults && faults.length) ? faults.length : 0
}

export function getHomogeneityCoef (circularGraphics) {
  const homogeneityData = circularGraphics && circularGraphics.homogeneity_data
  if (homogeneityData) {
    let csvLines = homogeneityData.split('\n') // CSV Input
    csvLines.shift()
    if (csvLines.length > 0) {
      let arrayValues = []

      const sumValues = csvLines.reduce((sum, line) => {
        line = line.replace(/\s+/g, '')
        if (line.length > 0) {
          let val = line.split(';')[1]
          if (val) {
            val = val.replace(',', '.')
            val = parseFloat(val)
            val && arrayValues.push(val)
            return sum + val
          }
        }
        return sum
      }, 0)
      const promValues = sumValues / arrayValues.length

      const sumDiffs = arrayValues.reduce((sum, val) => sum + Math.abs(val - promValues), 0)
      const promDiffs = sumDiffs / arrayValues.length

      return promValues ? Math.round(100 * (1 - (promDiffs / promValues))) : 0
    }
  }
  return 0
}

export function parseIOReportCsvData (circularGraphics) {
  const csvData = circularGraphics && circularGraphics.io_report_data
  const ioReportItems = circularGraphics && circularGraphics.io_report_items
  let newIoReportItems = null
  let newIoReportData = null

  if (csvData && csvData.length > 0 && ioReportItems && ioReportItems.length > 0) {
    const eachCsvData = csvData.split('id;')
    const parsedData = {}
    const ioIds = []
    let maxDataLen = 0

    // Parsing data for each Id
    eachCsvData.forEach(csv => {
      let data = csv.split('\n')
      const id = parseInt(data.shift())
      if (id && !isNaN(id)) {
        ioIds.push(id)
        let arrData = []
        for (let i = 0; i < data.length; i++) { // Average each 2 values
          const parseAndCheck = (line) => {
            let val = line.split(';')[1]
            val = val && parseFloat(val.replace(',', '.'))
            return !isNaN(val) && val
          }

          const val1 = parseAndCheck(data[i])
          if (val1 || val1 === 0) {
            const val2 = parseAndCheck(data[i + 1])
            if (val2 || val2 === 0) {
              arrData.push((val1 + val2) / 2)
              i++
            } else {
              arrData.push(val1)
            }
          }
        }

        if (arrData.length > maxDataLen) {
          maxDataLen = arrData.length
        }

        parsedData[id] = arrData
      }
    })

    if (ioIds.length > 0) {
      // Giving each item its csv data
      newIoReportItems = ioReportItems.map(item => {
        return {
          ...item,
          csvData: parsedData[item.id]
        }
      })

      // Getting average data
      const averageCsvData = []
      for (let i = 0; i < maxDataLen; i++) {
        let sum = 0
        newIoReportItems.forEach(item => {
          if (item.csvData && (item.csvData[i] || item.csvData[i] === 0)) {
            sum += item.csvData[i]
          }
        })

        averageCsvData.push(sum)
      }
      newIoReportData = averageCsvData
    }
  } else if (ioReportItems && ioReportItems.length > 0) {
    newIoReportItems = ioReportItems
  }

  return {
    'io_report_data': newIoReportData,
    'io_report_items': newIoReportItems
  }
}



// WEBPACK FOOTER //
// ./src/lib/reportsValuesGetters.js